module.exports = "<shelter-side-nav class=\"navigation-wrapper\"></shelter-side-nav>\n<div class=\"outlet-wrapper\"><router-outlet></router-outlet></div>\n"